import '@hotelescalle1/heyrev-core-kit/style.css'

import {
  applyColorCssVariables,
  CustomToastContainer
} from '@hotelescalle1/heyrev-core-kit'
import { configureAuthApi } from '@hotelescalle1/heyrev-core-kit/auth-api'
import { ThemeProvider } from '@mui/material/styles'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router'

import GridRemountBoundary from '@/components/GridRemountBoundary'
import RootStoreProvider from '@/store/StoreProvider'
import theme from '@/styles/theme'

import App from './App'

configureAuthApi({
  baseURL: import.meta.env.VITE_AUTH_API_URL,
  clientKey: import.meta.env.VITE_AUTH_CLIENT_KEY
})

applyColorCssVariables()

const container = document.getElementById('root')
if (!container) {
  throw new Error('Root container not found')
}
const root = createRoot(container, {
  onCaughtError: (error, errorInfo) => {
    // GridRemountBoundary already self-heals the known @mui/x-data-grid +
    // StrictMode crash (mui/mui-x#13356) by remounting — skip React's default
    // console noise for that specific boundary only, so other caught errors
    // still log normally.
    if (errorInfo.errorBoundary instanceof GridRemountBoundary) return
    console.error(error, errorInfo)
  }
})

root.render(
  <StrictMode>
    <RootStoreProvider>
      <ThemeProvider theme={theme}>
        <BrowserRouter>
          <App />
          <CustomToastContainer />
        </BrowserRouter>
      </ThemeProvider>
    </RootStoreProvider>
  </StrictMode>
)
